import {
  ActionButton,
  ButtonColumn,
  DateColumn,
  IconColumn,
  TableConfig,
  TextColumn,
} from 'ngx-eo-web-components';
import { Observable } from 'rxjs';
import { Surgery } from '../../core/models/surgery.model';
import { TableConfigBuilder } from '../../core/interfaces/ITableConfig';

export class CitizenSurgeriesTableConfigBuilder extends TableConfigBuilder<Surgery> {
  private idikaSurgeryOperationsEllipsisFunc:
    | ((item?: Surgery) => string)
    | undefined;

  private viewSurgeryFunc: ((item?: Surgery, event?: any) => void) | undefined;

  private searchAvailabilityFunc: ((item?: Surgery, event?: any) => void) | undefined;
  
  private surgeryStatusNameFunc: ((item?: Surgery) => string) | undefined;

  private isCancelSurgeryBtnVisibleFunc: ((item?: Surgery) => boolean) | undefined;

  private cancelSurgeryFunc: ((item?: Surgery, event?: any) => void) | undefined;


  getColumns() {
    const columns = [
      new TextColumn({
        name: 'Μον. κωδικός ΕΛΧ',
        propertyName: 'uniqueListPatientCode',
      }),
      new TextColumn({
        name: 'Voucher',
        propertyName: 'surgeryCode',
      }),
      new TextColumn({
        name: 'ΑΜΚΑ',
        propertyName: 'patientAmka',
      }),
      new TextColumn({
        name: 'Νοσοκομείο',
        propertyName: 'hospitalName',
      }),
      new TextColumn({
        name: 'Κλινική',
        propertyName: 'clinicName',
      }),
      new TextColumn({
        name: 'Τύπος',
        propertyName: 'surgeryType',
      }),
      new DateColumn({
        name: 'Ημ. κλινικής εκτίμησης',
        propertyName: 'examinationDate',
      }),
      new DateColumn({
        name: 'Ημ. εισαγωγής στην ΕΛΧ',
        propertyName: 'listEntryDate',
      }),
      new DateColumn({
        name: 'Ημ. αποδέσμευσης',
        propertyName: 'releaseDate',
        tooltip: (item?: Surgery) => {
          if (
            item?.surgeryStatusAlias == 'toprivate' &&
            item?.releaseDays &&
            item?.releaseDays > 0
          ) {
            return `${item.releaseDays} μέρες από την αποδέσμευση για ιδιωτική δομή`;
          }
          return '';
        },
      }),
      new DateColumn({
        name: 'Ημ. χειρουργείου',
        propertyName: 'surgeryDateTime',
      }),
      new TextColumn({
        name: 'Επεμβάσεις',
        propertyName: 'idikaSurgeryOperationsEllipsis',
        tooltip: (item?: Surgery) => {
          if (this.idikaSurgeryOperationsEllipsisFunc) {
            return this.idikaSurgeryOperationsEllipsisFunc(item);
          }
          return '';
        },
      }),
      new TextColumn({
        name: 'Κατάσταση',
        propertyName: 'surgeryStatusName',
        tooltip: (item?: Surgery) => {
          if (this.surgeryStatusNameFunc) {
            return this.surgeryStatusNameFunc(item);
          }
          return '';
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-eye p-info',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Προβολή',
          tooltipPosition: 'left',
        },
        action: (item?: Surgery, event?: any) => {
          if (this.viewSurgeryFunc) {
            this.viewSurgeryFunc(item, event);
          }
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-search p-primary',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Αναζήτηση διαθεσιμότητας ιδιωτικών δομών',
          tooltipPosition: 'left',
        },
        action: (item?: Surgery, event?: any) => {
          if (this.searchAvailabilityFunc) {
            this.searchAvailabilityFunc(item, event);
          }
        },
        isVisibleAction: (item?: Surgery) => {
          return item?.surgeryStatusAlias === "toprivate";
        } 
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-calendar-minus p-danger',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Ακύρωση Προγραμματισμού',
          tooltipPosition: 'left',
        },
        action: (item?: Surgery, event?: any) => {
          if (this.cancelSurgeryFunc) {
            this.cancelSurgeryFunc(item, event);
          }
        },
        isVisibleAction: (item?: Surgery) => {
          if (this.isCancelSurgeryBtnVisibleFunc) {
            return this.isCancelSurgeryBtnVisibleFunc(item);
          } else {
            return false;
          }
        },
      }),
    ];

    return columns;
  }

  addIdikaSurgeryOperationsEllipsisFunction(
    idikaSurgeryOperationsEllipsisFunc: (item?: Surgery) => string
  ): CitizenSurgeriesTableConfigBuilder {
    this.idikaSurgeryOperationsEllipsisFunc =
      idikaSurgeryOperationsEllipsisFunc;
    return this;
  }

  addSurgeryStatusNameFunction(
    surgeryStatusNameFunc: (item?: Surgery) => string
  ): CitizenSurgeriesTableConfigBuilder {
    this.surgeryStatusNameFunc = surgeryStatusNameFunc;
    return this;
  }

  addSearchAvailabilityFunction(
    searchAvailabilityFunc: (item?: Surgery, event?: any) => void
  ): CitizenSurgeriesTableConfigBuilder {
    this.searchAvailabilityFunc = searchAvailabilityFunc;
    return this;
  }

  
  addViewSurgeryFunction(
    viewSurgeryFunc: (item?: Surgery, event?: any) => void
  ): CitizenSurgeriesTableConfigBuilder {
    this.viewSurgeryFunc = viewSurgeryFunc;
    return this;
  }

  // addCancelSurgeryFunction(
  //   cancelSurgeryFunc: (item?: Surgery, event?: any) => void
  // ): CitizenSurgeriesTableConfigBuilder {
  //   this.cancelSurgeryFunc = cancelSurgeryFunc;
  //   return this;
  // }

  addIsCancelSurgeryBtnVisibleFunction(
    isCancelSurgeryBtnVisibleFunc: (item?: Surgery) => boolean
  ): CitizenSurgeriesTableConfigBuilder {
    this.isCancelSurgeryBtnVisibleFunc = isCancelSurgeryBtnVisibleFunc;
    return this;
  }

  addCancelSurgeryFuncion(
    cancelSurgeryFunc: (item?: Surgery, event?: any) => void
  ): CitizenSurgeriesTableConfigBuilder {
    this.cancelSurgeryFunc = cancelSurgeryFunc;
    return this;
  }

  getTable(data: Surgery[]): TableConfig<Surgery> {
    this.setTitle('')
      .setColumns(this.getColumns())
      .setTableData(data)
      .setLineNumbers(true);

    return this.getTableConfig();
  }
}
